import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Core/Button';
import isNil from 'utils/isNil';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';

const SimpleTextButtonSection = ({
  backgroundImg,
  colorScheme,
  title,
  subHead,
  description,
  buttonTitle,
  buttonLinkTo,
  utm,
  useModalForm,
  modalForm,
  ...otherProps
}) => {
  const [search, setSearch] = useState(undefined);
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  useEffect(() => {
    setSearch(window?.location?.search);
  }, []);

  return (
    <SectionCareerHero
      backgroundColor={!isNil(colorScheme) && colorScheme.includes('Blue') ? '#009DE6' : '#12889D'}
      backgroundImg={backgroundImg}
      titleColor="white"
      descriptionColor={!isNil(colorScheme) && colorScheme.includes('White') ? 'white' : 'primary'}
      buttonTitleColor={
        !isNil(colorScheme) && colorScheme.includes('White') ? '#0B1A21' : 'var(--white-color)'
      }
      {...otherProps}
    >
      <div className="section-text-button--container">
        {!isNil(subHead) && <p className="section-text-button--small-title">{subHead}</p>}
        <h2 className="section-text-button--title">{title}</h2>
        {description && <p className="section-text-button--description">{description}</p>}
        {useModalForm ? (
          <Button
            dataPosition="Conversion Panel - Stacked CTA"
            className="section-text-button--button"
            type={!isNil(colorScheme) && colorScheme.includes('White') ? 'white' : 'primary'}
            shadow={false}
            onClick={() => toggleIsModalOpen(true)}
          >
            {buttonTitle}
          </Button>
        ) : (
          <Button
            dataPosition="Conversion Panel - Stacked CTA"
            to={`${buttonLinkTo}${utm && search ? search : ''}`}
            className="section-text-button--button"
            type={!isNil(colorScheme) && colorScheme.includes('White') ? 'white' : 'primary'}
            shadow={false}
          >
            {buttonTitle}
          </Button>
        )}
      </div>

      {useModalForm && (
        <ModalMarketingForm
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          inlineMarketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </SectionCareerHero>
  );
};

SimpleTextButtonSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  backgroundImg: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

const SectionCareerHero = styled.div`
  padding: 0 20px;
  background: ${props =>
    props.backgroundImg != null ? 'url(' + props.backgroundImg + ')' : props.backgroundColor};
  background-repeat: no-repeat;
  background-size: cover;

  .section-text-button--container {
    padding: 80px 0;
    max-width: 990px;
    margin: 0 auto;
    text-align: center;

    .section-text-button--small-title {
      font-size: 16px;
      font-weight: 900;
      line-height: 110%;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: var(--blue-3);
    }

    .section-text-button--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: ${props => props.titleColor};
    }

    .section-text-button--description {
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;
      color: ${props => props.descriptionColor};
    }

    .section-text-button--button {
      font-weight: bold;
      font-size: 20px;
      line-height: 110%;
      color: ${props => props.buttonTitleColor};
      padding: 20px 24px;
      margin-top: 40px;
    }
  }

  @media (max-width: 768px) {
    .section-text-button--container {
      padding: 40px 0;
      max-width: 590px;

      .section-text-button--small-title {
        font-size: 15px;
        line-height: 20px;
      }

      .section-text-button--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }

      .section-text-button--description {
        font-size: 16px;
      }

      .section-text-button--button {
        font-size: 16px;
        padding: 15px 24px;
        margin-top: 24px;
      }
    }
  }

  @media (max-width: 576px) {
  }
`;

export default SimpleTextButtonSection;
